var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCommonIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.00140381,
    y: 0.360107,
    width: 33.2,
    height: 33.2,
    rx: 9.96,
    fill: "#F4F4F4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 24.2667V23.3334H11.8667V9.33337H19.3333V10.2667H22.1333V23.3334H24V24.2667H21.2V11.2H19.3333V24.2667H10ZM16.5333 17.5187C16.7262 17.5187 16.8942 17.4472 17.0373 17.304C17.1804 17.1609 17.252 16.9929 17.252 16.8C17.252 16.6072 17.1804 16.4392 17.0373 16.296C16.8942 16.1529 16.7262 16.0814 16.5333 16.0814C16.3404 16.0814 16.1724 16.1529 16.0293 16.296C15.8862 16.4392 15.8147 16.6072 15.8147 16.8C15.8147 16.9929 15.8862 17.1609 16.0293 17.304C16.1724 17.4472 16.3404 17.5187 16.5333 17.5187ZM12.8 23.3334H18.4V10.2667H12.8V23.3334Z",
    fill: "#999999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommonIcon);
export default __webpack_public_path__ + "static/media/commonIcon.0f51e9369aa86cdbf45640d92fc2bcf0.svg";
export { ForwardRef as ReactComponent };